import useGetNewspaperInitialValues from './useGetNewspaperInitialValues'

export default useGetNewspaperInitialValues
